module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Kick2.1a4ed0ea.png";